// extracted by mini-css-extract-plugin
export default {"link":"MenuBar_link__8D-n3","item":"MenuBar_item__JlZIl","icon":"MenuBar_icon__cu1vm","title":"MenuBar_title__eGDoK","active":"MenuBar_active__GgkaH"};